import React from "react";
import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import SessionExpiredNotice from "./components/SessionExpiredNotice";
import HomePage from "./pages/HomePage";
import RootPage from "./pages/RootPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import YandexCallbackPage from "./pages/YandexCallbackPage";
import GoogleCallbackPage from "./pages/GoogleCallbackPage";
import BanAppealsPage from "./pages/BanAppealsPage";
import DownloadPage from "./pages/DownloadPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import CabinetPage from "./pages/CabinetPage";
import UserProfilePage from "./pages/UserProfilePage";
import WalletPage from "./pages/WalletPage";
import GdMenuPage from "./pages/Gd/GdMenuPage";
import SupportPage from "./pages/SupportPage";
import SupportListPage from "./pages/SupportListPage";
import SupportTicketPage from "./pages/SupportTicketPage";
import TeamPage from "./pages/TeamPage";
import IdeasPage from "./pages/IdeasPage";
import IdeasListPage from "./pages/IdeasListPage";
import IdeaDetailPage from "./pages/IdeaDetailPage";
import MyIdeasPage from "./pages/MyIdeasPage";
import NewsListPage from "./pages/NewsListPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import NewsEditorPage from "./pages/NewsEditorPage";
import NotFoundPage from "./pages/NotFoundPage";

export default function App() {
  return (
    <>
      <ScrollToTop />
      <SessionExpiredNotice />
      <Routes>
        {/* Корень раздваивается: гостю витрина, вошедшему кабинет.
            /welcome — та же витрина, но ЯВНО: вошедший тоже должен
            иметь возможность на неё вернуться. */}
        <Route path="/" element={<RootPage />} />
        <Route path="/welcome" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/auth/yandex/callback" element={<YandexCallbackPage />} />
        <Route path="/oauth/google/callback" element={<GoogleCallbackPage />} />
        <Route path="/ban-appeals" element={<BanAppealsPage />} />
        <Route path="/ban-appeals/:id" element={<BanAppealsPage />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* Кабинет: один компонент, разделы определяются под-путём
            (/app, /app/top, /app/avatar, /app/friends, /app/settings,
            /app/help, /app/about, /app/wiki, /app/more, /app/game/:id).
            Конкретные роуты /app/profile/:userId и /app/gd ниже матчатся
            раньше (RR v7 — по специфичности). */}
        <Route path="/app/*" element={<CabinetPage />} />
        <Route path="/app/profile/:userId" element={<UserProfilePage />} />
        {/* Кошелёк — отдельная страница (2026-07-09, раньше модалка) */}
        <Route path="/app/wallet" element={<WalletPage />} />
        {/* Geometry Dash 2.0 — меню эпох/уровней. Порт /kubikon/gd
            из Майнкрафтии. Запуск уровня → ticket → player.rublox.pro. */}
        <Route path="/app/gd" element={<GdMenuPage />} />
        {/* Блог МИНа — devblog Рублокса (RUBLOX_DEVBLOG_PLAN.md) */}
        <Route path="/app/news" element={<NewsListPage />} />
        <Route path="/app/news/new" element={<NewsEditorPage />} />
        <Route path="/app/news/edit/:id" element={<NewsEditorPage />} />
        <Route path="/app/news/:id" element={<NewsDetailPage />} />
        {/* Тикет-система Рублокса (Аудит 3, Неделя 4) */}
        <Route path="/support" element={<SupportPage />} />
        <Route path="/support/my" element={<SupportListPage />} />
        <Route path="/support/ticket/:id" element={<SupportTicketPage />} />
        {/* Публичная страница команды (Аудит 4, Неделя 4) */}
        <Route path="/team" element={<TeamPage />} />
        {/* Народный роадмап (Аудит 2, Неделя 4) */}
        <Route path="/ideas" element={<IdeasPage />} />
        <Route path="/ideas/list" element={<IdeasListPage />} />
        <Route path="/ideas/my" element={<MyIdeasPage />} />
        <Route path="/ideas/:id" element={<IdeaDetailPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
